import { render, staticRenderFns } from "./KycSearch.vue?vue&type=template&id=4bb7e538&scoped=true&"
import script from "./KycSearch.vue?vue&type=script&lang=js&"
export * from "./KycSearch.vue?vue&type=script&lang=js&"
import style0 from "./KycSearch.vue?vue&type=style&index=0&id=4bb7e538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7e538",
  null
  
)

export default component.exports